import { Alert, Avatar, Box, Collapse, Container, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ExpandLess, ExpandMore, ReplayOutlined } from "@mui/icons-material";
import useGlobal from "./useGlobal";
import './shop.css'


export function MyOrders() {
    const [axios,setAxios] = useGlobal('axios')
    const [bestellungen,setBestellungen] = useState([])
    const [foruser,setForuser] = useGlobal('foruser',false)
    const [historieOpen,setHistorieOpen] = useState(false)


    useEffect(() => {
        console.log('mybestellungen')
        getData()
    },[])

    useEffect(() => {getData()},[foruser])



    const getData = () => {
        const params = {foruser:foruser}
        axios.get('bestellungen',{params}).then(result => {
            setBestellungen(result.data.own)
        })
    }

    return (
        <Container maxWidth='lg' className="mainblank">
            <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <Typography variant="body1">Abholung Di 8-15 Uhr & Fr 8-12 Uhr im Zentrallager KTW-Wache</Typography>
            <ReplayOutlined sx={{fontSize:'40px'}}onClick={e => getData()} />
            </Box>
        <Divider/>        
        {!!bestellungen?.filter(b => b.status === 2).length && <>
        <Typography variant="h5">Deine abholbereiten Bestellungen</Typography>
        {!!bestellungen?.filter(b => b.status < 2).length &&
            <Alert severity="warning" variant="filled" sx={{marginBottom:'10px'}}>Achtung! Nur Teillieferung — weitere Artikel sind noch im Zulauf.</Alert>
        }
        <List>
            {bestellungen.filter(b=> b.status === 2).map(b => 
            <>
            <ListItem key={'li_'+b.produkt}>
                {b.bild &&
                    <ListItemAvatar>
                        <Avatar src={'https://shop.rdheinsberg.de/api/bild/small_'+b.bild} />
                    </ListItemAvatar>
                }
                <ListItemText primary={
                    <React.Fragment>
                        <Typography variant="h6">{b.produkt}</Typography>
                        <Typography>{b.variante}</Typography>
                        <Typography>{b.customize}</Typography>
                    </React.Fragment>
                
                
                } 
                secondary={
                    <React.Fragment>
                        <Box>Bestellt am {b.bestelldatum}</Box>
                    </React.Fragment>
                    }/>
            </ListItem>
            <Divider variant="inset" component="li" />
            </>
            )}
        </List> 
        </>}
        <Divider sx={{marginTop:'20px', marginBottom:'15px', borderBottomWidth:'3px'}}/>
        {!!bestellungen?.filter(b => b.status < 2).length && <>
        <Typography variant="h5">Bestellungen im Zulauf</Typography>
        <List>
            {bestellungen.filter(b=> b.status < 2).map(b => 
            <>
            <ListItem key={'li_'+b.produkt}>
                {b.bild &&
                    <ListItemAvatar>
                        <Avatar src={'https://shop.rdheinsberg.de/api/bild/small_'+b.bild} />
                    </ListItemAvatar>
                }
                <ListItemText primary={
                    <React.Fragment>
                        <Typography variant="h6">{b.produkt}</Typography>
                        <Typography>{b.variante}</Typography>
                        <Typography>{b.customize} {b.custom_color}</Typography>
                    </React.Fragment>
                
                
                } 
                secondary={
                    <React.Fragment>
                        <Box>Bestellt am {b.bestelldatum}</Box>
                    </React.Fragment>
                    }/>
            </ListItem>
            <Divider variant="inset" component="li" />
            </>
            )}
        </List> 
        </>}
        <Divider sx={{marginBottom:'15px'}}/>    
        {!!bestellungen?.filter(b => b.status > 2).length && <>
        <Box sx={{display:'flex',alignItems:'center',cursor:'pointer'}} onClick={e => setHistorieOpen(!historieOpen)}>
            <Typography variant="h5">Historie</Typography>
            {historieOpen ? <ExpandLess/> : <ExpandMore/>}
        </Box>
        <Collapse in={historieOpen}>
        <List>
            {bestellungen.filter(b=> b.status > 2).map(b =>
            <>
            <ListItem key={'li_'+b.produkt}>
                {b.bild &&
                    <ListItemAvatar>
                        <Avatar src={'https://shop.rdheinsberg.de/api/bild/small_'+b.bild} />
                    </ListItemAvatar>
                }
                <ListItemText primary={
                    <React.Fragment>
                        <Typography variant="h6">{b.produkt}</Typography>
                        <Typography>{b.variante}</Typography>
                        <Typography>{b.customize} {b.custom_color}</Typography>

                    </React.Fragment>


                }
                secondary={
                    <React.Fragment>
                        <Box>Bestellt am {b.bestelldatum}</Box>
                        <Box>Abgeholt am {b.abholdatum} von {b.abholer}</Box>

                    </React.Fragment>
                    }/>
            </ListItem>
            <Divider variant="inset" component="li" />
            </>
            )}
        </List>
        <Box sx={{display:'flex',justifyContent:'space-around'}}>
            <div>Die ausgegebenen Artikel sind Eigentum der RDHS</div>
        </Box>
        </Collapse>
        <Box sx={{marginBottom:'20px'}}/>
        </>}

        </Container>
    )
}